import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { styleEntry } from '@mylighthouse/prism-ember';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface GeneralChartsLegendsLegendItemSignature {
  Args: {
    className?: string;
    color?: string;
    id: string;
    isDisabled?: boolean;
    isHidden?: boolean;
    legendItemClicked?: () => void;
    name?: string;
    tooltipContent?: string;
    type: string;
  };
  Blocks: {
    default: [];
  };
}

export default class GeneralChartsLegendsLegendItem extends Component<GeneralChartsLegendsLegendItemSignature> {
  @action legendItemClicked(): void {
    if (this.args.legendItemClicked) {
      this.args.legendItemClicked();
    }
  }

  <template>
    <button
      class="chart-legend-item button--unstyled flex flex-row items-center justify-center gap-100
        {{if @className @className}}
        {{if @isHidden 'chart-legend-item--hidden'}}"
      data-test-id="legend-item"
      disabled={{@isDisabled}}
      type="button"
      {{on "click" this.legendItemClicked}}
    >
      <div
        class="chart-legend-item__marker {{@type}} {{@id}}"
        style={{if @color (styleEntry "background-color" @color)}}
      ></div>
      {{#if @name}}
        <p class="text-200--medium truncate" title={{@name}}>{{@name}}</p>
      {{else}}
        <p class="text-200--medium truncate">
          {{yield}}
        </p>
      {{/if}}
      {{#if @tooltipContent}}
        <GeneralIconWithTooltip @tooltipContent={{@tooltipContent}} />
      {{/if}}
    </button>
  </template>
}
